import "core-js/modules/es6.object.freeze";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import { API_REQUEST } from '@/api/';
import { serializeAsQueryString } from '@/api/serialize';
var graphTypeByTableView = {
  'planBothCompare': 'plan_edit',
  'planApproved': 'plan_approved',
  'factBothCompare': 'fact_edit',
  'factApproved': 'fact_approved',
  'factTabel': 'fact_approved'
};
export var updateEfficiency = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var commit, rootState, state, rootGetters, getters, workTypeIds, _ref2$uploadShedule, uploadShedule, requestObject, cachedDataKey, res;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, rootState = _ref.rootState, state = _ref.state, rootGetters = _ref.rootGetters, getters = _ref.getters;
            workTypeIds = _ref2.workTypeIds, _ref2$uploadShedule = _ref2.uploadShedule, uploadShedule = _ref2$uploadShedule === void 0 ? null : _ref2$uploadShedule;
            requestObject = {
              'shop_id': rootGetters['queryMirrored/getOneDep'],
              'work_type_ids': workTypeIds,
              'from_dt': getters['visibleDates'][0],
              'to_dt': getters['visibleDates'].slice(-1)[0],
              'graph_type': graphTypeByTableView[rootState.queryMirrored.tableView]
            };
            cachedDataKey = serializeAsQueryString(requestObject);

            if (!(state.cachedData.efficiency[cachedDataKey] && !uploadShedule)) {
              _context.next = 8;
              break;
            }

            res = [true, state.cachedData.efficiency[cachedDataKey]];
            _context.next = 12;
            break;

          case 8:
            _context.next = 10;
            return API_REQUEST('getCoverageChartsData', requestObject);

          case 10:
            res = _context.sent;
            commit('setCache', {
              name: 'efficiency',
              key: cachedDataKey,
              value: res[1]
            });

          case 12:
            commit('setEfficiency', res[1]);
            return _context.abrupt("return", res[1]);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateEfficiency(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var setEfficiency = function setEfficiency(state, value) {
  state.efficiency = Object.freeze(value);
};